import { IInstrumentosEjecucion } from "../../../interfaces/InstrumentosEjecucion";
import { IInformacionGeneral } from "../../../interfaces/InformacionGeneral";
import { Sections } from "../../../util/types";
import Intro from "./Intro";
import Iniciativas from "./Iniciativas";
import Resultados from "./Resultados";
import Avance from "./Avance";

const SubSectionsContainer:React.FC<{ 
    code: string,
    section:Sections,
    avance?:number,
    ejecucion?: IInstrumentosEjecucion
    infoGeneral?: IInformacionGeneral
}>  = ({code, section, avance, ejecucion, infoGeneral}) => {
    switch (section) {
        case "intro": 
            return <Intro code={code}/>
        case "initiatives":
            return <Iniciativas code={code} />
        case "results":
            return <Resultados code={code} />
        case "advance":
            return <Avance porcentajeAvance={infoGeneral?.porcentajeAvance}/>
        default:
            return <Intro code={code}/>
            break;
    }
}

export default SubSectionsContainer